module.exports = __webpack_public_path__ + "static/media/Fly dina undanflykter.f33512c3.pdf";